"use client";
import * as React from "react";
const SvgShoppingCartOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.64 8.8c.6 0 1.12-.33 1.4-.82l2.86-5.2a.8.8 0 0 0-.7-1.18H3.37L2.62 0H0v1.6h1.6l2.88 6.07L3.4 9.62A1.6 1.6 0 0 0 4.8 12h9.6v-1.6H4.8l.88-1.6zM4.13 3.2h9.71l-2.2 4H6.02zm.67 9.6a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0-.01-3.2m8 0a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2" }));
export {
  SvgShoppingCartOutlined as default
};
